import { sessionState } from '../auth/session-state';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MfaChallengeService } from './mfa-challenge.service';
import * as myGlobalsfunc from '../global.function';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-mfa-challenge',
  templateUrl: './mfa-challenge.component.html',
  styleUrls: ['./mfa-challenge.component.scss'],
  standalone: false,
})
export class MfaChallengeComponent implements OnInit {

  mfaForm: UntypedFormGroup;
  public mfaCode: any;
  public msgs = [];
  private numberReg: RegExp;
  public limitResend: Boolean = false;
  public submitted = false;

  constructor(
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private renderer: Renderer2,
    private router: Router,
    private mfaChallengeService: MfaChallengeService,
    private auth: AuthService,
  ) {
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.numberReg = new RegExp('^[0-9]*$');
    this.renderer.addClass(document.body, 'userNotLoggedIn');
    this.spinner.hide();
    this.mfaForm = this.formBuilder.group({
      challengeCode: [
        '',
        [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(6), Validators.max(999999)]
      ]
    });
  }

  codeLength(event) {
    if(this.mfaForm.get('challengeCode').value.length >= 6 || !this.numberReg.test(event.key)) {
      event.preventDefault();
    }
  }

  backToLogin() {
    this.spinner.show();
    const userId = sessionState.getItem('user_id');
    const token = sessionState.getItem('id_token');

    if(userId !== '' && userId !== '0' && token !== '') {
      this.mfaChallengeService.clearSession({ user_id: userId, token: token })
        .subscribe(
          (res: any) => {
            sessionState.clear();
            this.auth.deleteCookie()
            this.spinner.hide();
            this.router.navigate(['/login']);
            return;
          }
        );
    } else {
      this.auth.deleteCookie()
      sessionState.clear();
      this.spinner.hide();
      this.router.navigate(['/login']);
      return;
    }
  }

  resendCode() {
    this.limitResend = true;
    this.msgs = [];
    this.spinner.show();

    setTimeout(() => {
      this.limitResend = false;
    }, 30000); 

    this.mfaChallengeService.resendCode({isMFAChallenge: true})
      .subscribe(
        (res: any) => {
          if(res.status === 1) {
            this.spinner.hide();
          } else {
            this.showError('error', res.message);
            this.spinner.hide();
            return;
          }
        }
      );
  }

  showError(type, message) {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: message });
  }

  onSubmit() {
    if (this.mfaForm.invalid) {
      return;
    }
    this.spinner.show();
    this.msgs = [];

    this.mfaChallengeService.challengeCode({ code: this.mfaForm.get('challengeCode').value, isMFAChallenge: true })
      .subscribe(
        (res: any) => {
          if (res.status === 1 && res.mfa_passed === 1) {
            sessionState.setItem('mfa_passed', 1);
            sessionState.setItem('mfa_expiry', res.mfa_expiry);
            sessionState.setItem('mfa_email_sent', '0');

            this.router.navigate(['']);
            return;
          } else {
            window.scroll(0, 0);
            this.showError('error', res.message);
            this.spinner.hide();
            return;
          }
        }
      );
  }

  get f() {
    return this.mfaForm.controls;
  }

}
